import React from 'react';
import { getNumberColor, saveNumbers } from '../utils/storage';
import ShareButton from './ShareButton';

function NumberDisplay({ generatedData, onSave }) {
  if (!generatedData) {
    return null;
  }

  const { numbers, model } = generatedData;

  const handleSave = (numberSet) => {
    try {
      saveNumbers(numberSet, model);
      alert('번호가 저장되었습니다!');
      if (onSave) onSave();
    } catch (error) {
      alert('저장 중 오류가 발생했습니다.');
    }
  };

  const getModelName = (modelId) => {
    const names = {
      'random': '완전 랜덤',
      'high-freq': '고빈도 번호',
      'low-freq': '저빈도 번호',
      'pattern': '패턴 기반',
      'exclude': '제외 번호',
      'fixed': '고정 번호',
      'hybrid': '혼합 전략'
    };
    return names[modelId] || modelId;
  };

  return (
    <div className="number-display">
      <div className="display-header">
        <h2>생성된 번호</h2>
        <span className="model-badge">{getModelName(model)}</span>
      </div>

      {numbers.map((numberSet, setIdx) => (
        <div key={setIdx} className="number-set">
          <div className="set-header">
            <span className="set-number">세트 {setIdx + 1}</span>
          </div>

          <div className="number-row">
            {numberSet.map((num, idx) => (
              <div
                key={idx}
                className="number-ball large"
                style={{ backgroundColor: getNumberColor(num) }}
              >
                {num}
              </div>
            ))}
          </div>

          <button
            className="save-button"
            onClick={() => handleSave(numberSet)}
          >
            이 번호 저장하기
          </button>

          <ShareButton
            type="lotto"
            data={{ numbers: numberSet }}
          />
        </div>
      ))}
    </div>
  );
}

export default NumberDisplay;
